<template>
    <div class="form">
        <h4 class="step-title">
            Do you own this home?
        </h4>
        <div class="step-content d-flex flex-column align-items-center">
            <yes-no-button-list v-bind:onclick="complete" v-bind:value="lead.homeInsurance.ownHome"/>
        </div>
    </div>
</template>

<script>
    import YesNoButtonList from "../shared/YesNoButtonList.vue"

    export default {
        name: "OwnHome",
        components: {
            YesNoButtonList
        },
        props: {
            lead: Object
        },
        methods: {
          complete: function(value) {
              this.lead.homeInsurance.ownHome = value;
              this.$emit("complete", this.$options.name, value);
          }
        }
    }
</script>
